import { post } from '../../utils/fetchAPI';

/**
 * POST /upload/image — multipart `file`, optional `purpose`, optional `organization`.
 * Omit `purpose` to use API default destination (e.g. prescription background).
 */
export function postDoctorImageUpload(file, { purpose, organizationId } = {}) {
    const fd = new FormData();
    fd.append('file', file);
    if (purpose) {
        fd.append('purpose', purpose);
    }
    if (organizationId) {
        fd.append('organization', organizationId);
    }
    return post('upload/image', fd);
}
